import { defineVfConfig } from "./vf/config/VfConfig"

export default defineVfConfig({})
